import { Action } from '@ngrx/store';
import { FiltriAllegati } from '../filtri-allegati.model';

/**Azione per avviare le operazioni di filtro */
export const START_FILTRI = '[ALLEGATI] Inizio filtro biografie';
/**Azione per ripulire lo stato dei filtri allegati */
export const CLEAR_FILTRI = '[ALLEGATI] Svuotamento dei filtri sullo stato';

/**Classe per l'avvio dei filtri allegati */
export class StartFiltriAllegati implements Action {
    readonly type = START_FILTRI;

    /**
     * Costruttore per l'azione StartFiltriAllegati
     * @param payload {object} currentSection string (none|files|bio) e filters FiltriAllegati
     */
    constructor(
        public payload: {
            currentSection: string, 
            filters: FiltriAllegati
        }
    ) {}
}

/**Classe per la pulizia dello stato dai filtri non in uso */
export class ClearFiltri implements Action {
    readonly type = CLEAR_FILTRI;
}

export type AllegatiAction = 
| StartFiltriAllegati
| ClearFiltri;